import React from 'react';
import './aboutcontent.css';
import bg from '../../../assets/hive.webp';
import ie from '../../../assets/ie.jpeg';
import students from '../../../assets/students.webp';

const AboutContent = () => {
  return (
    <div>
      <section id="aboutImg">
        <div className="aboutImgText">
          <span className='aboutTitle'>About Us</span>
          <img src={bg} className="bg" alt="Profile" />
        </div>
      </section>
      <section id="aboutDesc">
        <div className="grid-container">
          <div className="grid-item grid-1">
            <img src={students} className='img' alt=""/>
          </div>
          <div className="grid-item grid-2">
            <h2>Build the future - together</h2><br/>
            <p className='textDesc'>
              Connect with other entrepreneurs to bring ideas to life. 
            </p>
          </div>
          <div className="grid-item grid-3">
            <h2>What's an idea without the right team to bring it to life?</h2><br/>
            <p className='textDesc'>
            Finding the right people can be tough. Whether it's a designer looking for a developer, or a business mind searching for a technical co-founder — collaboration shouldn't be a barrier. We created this platform because we believe every great idea deserves a chance, and that chance starts with the right team. Here, students can share their ideas, discover collaborators, and turn concepts into real projects — together.
            </p>
          </div>
          <div className="grid-item grid-4">
            <img src={ie} className='img' alt=''/>
          </div>
          <div className="grid-item full-width grid-5">
            <h2>Who Are We</h2><br/>
            <p className='textDesc'>We’re a group of undergrads who know the struggle of finding teammates all too well. Whether it was for a hackathon, a class project, or a startup idea — we kept running into the same problem: it's hard to find the right people to work with. So we built the thing we wished we had — a platform where students can easily connect, share ideas, and start building together.</p>
          </div>
        </div>
      </section>
    </div>
  )
}
export default AboutContent;